import getWithToken from './base/get-with-token'

const getDataResponsiveMeter = (date, searchData) => getWithToken(`/dashboard/responsive-meter?date=${date}`)(searchData)

export default getDataResponsiveMeter